<template>
	<div class="wrap">
		<Title :title="vacationName"></Title>
		<div class="activity-form-wrap">
			<el-form :inline="true" class="activity-form">
				<el-form-item label="昵称">
					<el-input v-model="nickName" placeholder="请输入昵称" clearable></el-input>
				</el-form-item>
				<el-form-item label="动态">
					<el-input v-model="title" placeholder="请输入动态" clearable></el-input>
				</el-form-item>
				<el-form-item label="动态类型">
					<el-select v-model="feedType" @change="setSelectedType">
						<el-option label="全部" value=""></el-option>
						<el-option label="文字动态" value="0"></el-option>
						<el-option label="图片动态" value="1"></el-option>
						<el-option label="视频动态" value="2"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="任务动态">
					<el-select v-model="taskFlag" @change="setSelectedTask">
						<el-option label="全部" value=""></el-option>
						<el-option label="否" value="0"></el-option>
						<el-option label="是" value="1"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="置顶">
					<el-select v-model="vacationUpFlag" @change="setSelectedUp">
						<el-option label="全部" value=""></el-option>
						<el-option label="否" value="0"></el-option>
						<el-option label="是" value="1"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button icon="el-icon-search" size="mini" type="primary" @click="toSearch">搜索</el-button>
					<el-button icon="el-icon-refresh" size="mini" @click="toReset">重置</el-button>
				</el-form-item>
			</el-form>
		</div>
		<el-table border size="mini" :data="dataList" style="width: 100%">
			<el-table-column prop="nickName" label="昵称">
			</el-table-column>
			<el-table-column label="动态">
				<template slot-scope="scope">
					<div class="feed-title" v-html="scope.row.title"></div>
				</template>
			</el-table-column>
			<el-table-column prop="feedType" label="动态类型" width="90">
				<template slot-scope="scope">
					<span v-if="scope.row.feedType==0">文字动态</span>
					<span v-if="scope.row.feedType==1">图片动态</span>
					<span v-if="scope.row.feedType==2">视频动态</span>
				</template>
			</el-table-column>
			<el-table-column prop="praiseNum" label="点赞数" width="90">
			</el-table-column>
			<el-table-column prop="commentNum" label="评论数" width="90">
			</el-table-column>
			<el-table-column prop="taskFlag" label="任务动态" width="90">
				<template slot-scope="scope">
					<span v-if="scope.row.taskFlag==0">否</span>
					<span v-if="scope.row.taskFlag==1">是</span>
				</template>
			</el-table-column>
			<el-table-column prop="addTime" label="发布时间">
				<template slot-scope="scope">
					<span>{{scope.row.addTime | datefmt2('YYYY-MM-DD HH:mm')}}</span>
				</template>
			</el-table-column>
			<el-table-column prop="vacationUpFlag" label="置顶状态" width="90">
				<template slot-scope="scope">
					<el-switch
					@click.native.prevent="changeFlag(scope.row)"
					v-model="scope.row.vacationUpFlag"
					disabled
					active-color="#13ce66"
					inactive-color="#ff4949">
					</el-switch>
				</template>
			</el-table-column>
			<el-table-column prop="name" label="操作" width="100">
				<template slot-scope="scope">
					<el-dropdown>
						<span class="el-dropdown-link">
							...
						</span>
						<el-dropdown-menu slot="dropdown" class="dropdown-new">
							<el-dropdown-item v-if="scope.row.feedType==1" @click.native="toPicture(scope.row)">图片预览</el-dropdown-item>
							<el-dropdown-item v-if="scope.row.feedType==2" @click.native="toVideo(scope.row)">视频观看</el-dropdown-item>
							<el-dropdown-item @click.native="toDetailFeed(scope.row)">详情</el-dropdown-item>
							<el-dropdown-item @click.native="toComment(scope.row)">评价列表</el-dropdown-item>
							<el-dropdown-item v-if="scope.row.enrollId" @click.native="toDetailEnroll(scope.row)">报名详情</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</template>
			</el-table-column>
		</el-table>
		<Pagination :total="total" :pageSize="pageSize" @pageChange="handleCurrentChange"/>
		<!--视频预览-->
		<el-dialog title="视频预览" :visible.sync="videoDialog" width="50%" @close="handleClose('video')">
			<div class="video-wrap">
				<video controls muted autoplay :src="feedDetailModel.fileUrl"></video>
			</div>
		</el-dialog>
		<!--图片预览-->
		<el-dialog title="图片预览" :visible.sync="imgDialog" width="50%" @close="handleClose('img')">
			<div class="picture-wrap">
				<div class="picture-list" v-for="item in feedDetailModel.attachList">
					<!-- <img :src="item.fileUrl"/> -->
					<el-image
					    style="width: 100%; height: 100px;"
					    :src="item.fileUrl"
					    :preview-src-list="attachList">
					  </el-image>
				</div>
			</div>
		</el-dialog>
		<!--动态详情弹窗-->
		<el-dialog title="动态详情" :visible.sync="feedDetailDialog" width="50%" @close="handleClose('feed')">
			<table class="table-column2">
				<tr>
					<th>动态</th>
					<td>{{feedDetailModel.title}}</td>
				</tr>
				<tr>
					<th>动态类型</th>
					<td>
						<span v-if="feedDetailModel.feedType==0">文字动态</span>
						<span v-if="feedDetailModel.feedType==1">图片动态</span>
						<span v-if="feedDetailModel.feedType==2">视频动态</span>
					</td>
				</tr>
				<tr>
					<th>审核状态</th>
					<td>
						<span v-if="feedDetailModel.status==0">未通过审核</span>
						<span v-if="feedDetailModel.status==1">已审核通过</span>
					</td>
				</tr>
				<tr>
					<th>动态资源</th>
					<td></td>
				</tr>
				<tr>
					<th>地区</th>
					<td></td>
				</tr>
				<tr>
					<th>纬度</th>
					<td></td>
				</tr>
				<tr>
					<th>经度</th>
					<td></td>
				</tr>
				<tr>
					<th>分享数</th>
					<td></td>
				</tr>
				<tr>
					<th>点赞数</th>
					<td>{{feedDetailModel.praiseNum}}</td>
				</tr>
				<tr>
					<th>评论数</th>
					<td>{{feedDetailModel.commentNum}}</td>
				</tr>
				<tr>
					<th>图片数</th>
					<td>{{feedDetailModel.picNum}}</td>
				</tr>
				<tr>
					<th>任务动态</th>
					<td>
						<span v-if="feedDetailModel.taskFlag==0">否</span>
						<span v-if="feedDetailModel.taskFlag==1">是</span>
					</td>
				</tr>
				<tr>
					<th>置顶状态</th>
					<td>
						<span v-if="feedDetailModel.vacationUpFlag==0">否</span>
						<span v-if="feedDetailModel.vacationUpFlag==1">是</span>
					</td>
				</tr>
			</table>
		</el-dialog>
		<!--报名表详情弹窗-->
		<el-dialog title="报名详情" :visible.sync="enrollDetailDialog" width="50%" @close="handleClose('enroll')">
			<table class="table-column2">
				<tr>
					<th>假期名称</th>
					<td>{{enrollDetailModel.vacationName}}</td>
				</tr>
				<tr>
					<th>姓名</th>
					<td>{{enrollDetailModel.realName}}</td>
				</tr>
				<tr>
					<th>学校</th>
					<td>{{enrollDetailModel.schoolName}}</td>
				</tr>
				<tr>
					<th>年级</th>
					<td>{{enrollDetailModel.grade}}</td>
				</tr>
				<tr>
					<th>学生证</th>
					<td>
						<img v-if="enrollDetailModel.cardFileUrl" :src="enrollDetailModel.cardFileUrl"/>
					</td>
				</tr>
				<tr>
					<th>专业</th>
					<td>{{enrollDetailModel.major}}</td>
				</tr>
				<tr>
					<th>省份名称</th>
					<td>{{enrollDetailModel.provinceName}}</td>
				</tr>
				<tr>
					<th>城市名称</th>
					<td>{{enrollDetailModel.cityName}}</td>
				</tr>
				<tr>
					<th>区县名称</th>
					<td>{{enrollDetailModel.districtName}}</td>
				</tr>
				<tr>
					<th>详细地址</th>
					<td>{{enrollDetailModel.returnAddress}}</td>
				</tr>
				<tr>
					<th>身份证号</th>
					<td>{{enrollDetailModel.idCard}}</td>
				</tr>
				<tr>
					<th>会员电话</th>
					<td>{{enrollDetailModel.phone}}</td>
				</tr>
				<tr>
					<th>配送地址</th>
					<td>{{enrollDetailModel.expAddressDetail}}</td>
				</tr>
				<tr>
					<th>审核状态</th>
					<td>
						<span v-if="enrollDetailModel.auditStatus=='0'">未审核</span>
						<span v-if="enrollDetailModel.auditStatus=='1'">已审核</span>
						<span v-if="enrollDetailModel.auditStatus=='2'">审核未通过</span>
					</td>
				</tr>
				<tr>
					<th>参加状态</th>
					<td>
						<span v-if="enrollDetailModel.joinStatus==1">确认参加</span>
						<span v-if="enrollDetailModel.joinStatus==0">未确认</span>
					</td>
				</tr>
			</table>
		</el-dialog>
	</div>
</template>

<script>
	import Title from '@/components/titleAdmin'
	import Pagination from '@/components/admin/pagination'
	import qs from 'qs'
	import { post,ajaxParam } from '@/units/request.js'
	export default {
		name: 'FeedList',
		components: {
			Title,
			Pagination
		},
		data() {
			return {
				pageNum: 1,
				pageSize: 10,
				total: 0,
				dataList: [],
				vacationId: '',
				vacationName: '',
				nickName: '', //昵称
				feedType: '',  //0文字动态1图片动态2视频动态
				title: '', //账号
				taskFlag: '', //任务动态0否1是
				vacationUpFlag: '', //活动置顶状态0未置顶,1置顶
				feedDetailDialog: false, //动态详情弹窗
				feedDetailModel: {},
				status: '',//动态审核状态(0未通过审核,1已经审核通过)
				enrollDetailDialog: false,
				enrollDetailModel: {},
				videoDialog: false,
				imgDialog: false,
				attachList: []
			}
		},
		created(){
			this.vacationId = this.$route.query.id||''
			this.getDataList()
		},
		methods: {
			//获取动态  新加只显示审核通过的
			async getDataList() {
				let param = {
					vacationId: this.vacationId,
					nickName: this.nickName,
					title: this.title,
					feedType: this.feedType,
					taskFlag: this.taskFlag,
					vacationUpFlag: this.vacationUpFlag,
					status: 1,
					pageNum: this.pageNum,
					pageSize: this.pageSize
				}
				ajaxParam(param)
				const res = await post('admin/feed/list', qs.stringify(param))
				if (res.data.code == 200) {
					let datalist = res.data.page.items
					datalist.forEach(item => {
						item.vacationUpFlag = item.vacationUpFlag == '1' ? true : false
					})
					this.dataList = datalist
					this.total = res.data.page.count
					this.vacationName = res.data.vacationName
					this.vacationId = res.data.vacationId
				}
			},
			//分页
			handleCurrentChange(e){
				this.dataList = []
				this.pageNum = e.number
				this.getDataList()
			},
			toSearch(){
				this.pageNum = 1
				this.total = 0
				this.getDataList()
			},
			toReset(){
				this.nickName = ''
				this.title = ''
				this.feedType = ''
				this.vacationUpFlag = ''
				this.taskFlag = ''
				this.pageNum = 1
				this.dataList = []
				this.getDataList()
			},
			setSelectedType(e){
				this.feedType = e
				this.pageNum = 1
				this.dataList = []
				this.getDataList()
			},
			setSelectedTask(e){
				this.taskFlag = e
				this.pageNum = 1
				this.dataList = []
				this.getDataList()
			},
			setSelectedUp(e){
				this.vacationUpFlag = e
				this.pageNum = 1
				this.dataList = []
				this.getDataList()
			},
			changeFlag(row){
				let status = row.vacationUpFlag?'取消置顶':'置顶'
				this.$confirm('确定要'+status+'吗？', '温馨提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					let param = {
						id: row.id,
						vacationUpFlag: row.vacationUpFlag?'0':'1'
					}
					ajaxParam(param)
					const res = await post('admin/feed/updateVacationUpFlag', qs.stringify(param))
					if (res.data.code == 200) {
						console.log(res.data)
						this.dataList.forEach(item=>{
							if(item.id==row.id){
								item.vacationUpFlag = item.vacationUpFlag?false:true
							}
						})
					}
				}).catch(() => {

				})
			},
			//视频预览
			toVideo(row){
				this.getFeedDetail(row)
				this.videoDialog = true
			},
			//图片预览
			toPicture(row){
				this.getFeedDetail(row)
				this.imgDialog = true
			},
			//评价列表
			toComment(row){
				this.$router.push({
					path: '/admin/activity/commentList?id='+row.id
				})
			},
			//动态详情
			toDetailFeed(row){
				this.feedDetailDialog = true
				this.getFeedDetail(row)
			},
			async getFeedDetail(row){
				let param = {
					id: row.id
				}
				ajaxParam(param)
				const res = await post('admin/feed/detail', qs.stringify(param))
				if (res.data.code == 200) {
					console.log(res.data)
					let entity = res.data.entity
					this.feedDetailModel = entity
					if(entity.feedType ==1){
						entity.attachList.forEach(item=>{
							this.attachList.push(item.fileUrl)
						})
						console.log('=========================')
						console.log(this.attachList)
					}
				}
			},
			//报名详情
			async toDetailEnroll(row){
				this.enrollDetailDialog = true
				let param = {
					enrollId: row.enrollId
				}
				ajaxParam(param)
				const res = await post('admin/feed/enroll/detail', qs.stringify(param))
				if (res.data.code == 200) {
					console.log(res.data)
					this.enrollDetailModel = res.data.entity ||{}
				}
			},
			handleClose(type){
				if(type=='img'){
					this.imgDialog = false
				} else if(type=='video'){
					this.videoDialog = false
				} else if(type=='feed'){
					this.feedDetailDialog = false
				} else{
					this.enrollDetailDialog = false
				}
			}
		}
	}
</script>

<style scoped lang="less">
	@import url("../../table.less");
	.wrap {
		background: #fff;
		border: 1px solid #e4e4e4;
		border-radius: 4px;
		margin-bottom: 10px;
		padding: 10px;
	}
	.export-wrap{
		display: flex;
		justify-content: flex-end;
		padding: 10px 0 15px;
	}
	/deep/ .el-form-item {
		margin-bottom: 0;
	}
	/deep/ .activity-form-wrap .el-input__inner {
		width: 160px;
		height: 30px;
		line-height: 30px;
		font-size: 12px!important;
	}

	/deep/ .el-button--primary {
		background: #EB6B1B;
		border-color: #EB6B1B;
	}

	/deep/ .el-button--mini,
	.el-button--mini.is-round {
		padding: 4px 8px;
	}

	/deep/ .el-button {
		font-size: 12px !important;
	}
	/deep/ .el-switch.is-disabled {
	 opacity: 1;
	}
	/deep/ .el-switch.is-disabled .el-switch__core, /deep/ .el-switch.is-disabled .el-switch__label {
	  cursor: pointer !important;;
	}
	/deep/ .el-dialog__header {
		padding-top: 15px;
		padding-bottom: 15px;
		border-bottom: 1px solid #DBDCDC !important;
	}
	/deep/ .el-dialog__body {
		padding-top: 10px;
	}
	.dropdown-new{
		li{
			height: 26px;
			line-height: 26px;
			font-size: 12px;
			color: #EB6B1B;
		}
		li:hover{
			background: none;
			text-decoration: underline;
			color: #EB6B1B;
		}
	}
	.video-wrap{
		video{
			width: 100%;
			max-width: 100%;
			max-height: 400px;
		}
	}
	.feed-title{
		text-overflow:ellipsis;
		display:-webkit-box;
		-webkit-line-clamp:3;
		overflow:hidden;
		-webkit-box-orient:vertical
	}
	.picture-wrap{
		display: flex;
		flex-wrap: wrap;
		.picture-list{
			width: 31.3%;
			margin: 0 1% 5px;
		}
	}
</style>
